export default "__VITE_ASSET__DcQzAcur__"